import axios from 'axios';

const api = axios.create({
  baseURL:'https://deshboard-hamburgueria-admin-backend-production.up.railway.app' 
});

export default api;